export default function formatNamePosessive(name: string) {
  if (!name) return "";
  return name.endsWith("s") ? `${name}'` : `${name}'s`;
}
